'use client';

import type { FlogHeaders } from '../headers';
import { X_FLOG_ID } from '../headers';

export const MAX_BATCH_SIZE = 1000;
export const BATCH_DELAY_MS = 1;

let fetching: Promise<FlogHeaders> | null = null;
export async function getFlogHeaders(): Promise<FlogHeaders | null> {
  if (typeof window === 'object') {
    return window['.flog'] ?? null;
  }
  if (fetching) return fetching;
  fetching = fetch('/api/flog').then((rsp) => rsp.json());
  return fetching;
}

export async function sendLogs(
  lines: {
    message: string;
    data: any;
  }[]
): Promise<void> {
  if (await getFlogHeaders()) {
    await fetch('/api/flog', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
      body: JSON.stringify(lines),
    });
  }
}

if (typeof window === 'object') {
  if (!window['.flog']) {
    const headers = Object.freeze(
      Object.fromEntries(
        [...document.cookie.matchAll(/(x-flog-[^=]+)=([^;]+)/g)].map(
          ([__, k, v]) => [k, v]
        )
      )
    );
    if (headers[X_FLOG_ID]?.startsWith('enabled-')) {
      window['.flog'] = headers as FlogHeaders;
      // eslint-disable-next-line no-console
      console.log('Flow log IDs:', window['.flog']);
    }
  }
}
